export default {
  name: 'Conference of Montreal',
  shortName: 'Montreal',
  description:
    'The Conference of Montreal (CDM) was launched in 1994 and brings together decision makers from all spheres of society to address the most pressing issues of our time.',
  thumbnail: '/images/events/montreal/thumbnail-montreal.jpg',
  link: 'https://www.laconferencedemontreal.com/',
  header: {
    content:
      'The Conference of Montreal (CDM) was launched in 1994 and brings together decision makers from all spheres of society to address the most pressing issues of our time.'
  },
  bullets: {
    bullet1: {
      number: '30th',
      label: 'Edition'
    },
    bullet2: {
      number: '2 100+',
      label: 'In-Person Participants'
    },
    bullet3: {
      number: '130+',
      label: 'Speakers'
    },
    bullet4: {
      number: '40+',
      label: 'Represented Countries'
    }
  },
  about: {
    title: 'Our Purpose',
    content:
      'Over the past three decades, CDM has evolved to become an internationally recognised multi-day event attended by world leaders and decision makers from the worlds of government, business and academia, who convene to discuss topics ranging from the economy and global leadership to sustainability, energy and innovation. The event’s geographic location in the heart of French Canada offers audiences a rare sociopolitical economic insight which spans both a North American and European perspective, while also examining best practice worldwide.'
  },
  next: {
    title: '',
    content: ''
  },
  gallery: {
    title: 'Photo gallery',
    edition29: {
      title: '29th edition — Thriving in a world in transition',
      index: [
        {
          image: '/images/events/toronto/gallery/16th-toronto-001.jpg'
        }
      ]
    }
  },
  board: {
    uptitle: 'About',
    title: 'Board of Governors',
    content:
      'The Conference of Montreal leadership team works closely with a select group of individuals who form our Board of Governors. All members of the Conference of Montreal Board of Governors have been carefully selected for their in-depth knowledge and experience within their respective fields.'
  },
  boardIndex: {
    chairmen: {
      title: 'Co-Chairmen',
      index: [
        {
          name: 'Paul Desmarais Jr.',
          info: 'Chairman, Power Corporation of Canada (PCC)',
          image: '/images/boards/montreal/paul_desmarais_jr.png'
        },
        {
          name: 'Gil Rémillard',
          info: 'Founding Chairman, International Economic Forum of the Americas',
          image: '/images/boards/montreal/Gil_Remillard-2292_HR.jpg'
        }
      ]
    },
    members: {
      title: 'Members',
      index: [
        {
          name: 'Luis Almagro Lemes',
          info: 'Secretary General, Organization of American States (OAS)',
          image: '/images/boards/montreal/almagro-luis.jpg'
        },
        {
          name: 'Joseph J. Andrew',
          info: 'Global Chair, Dentons',
          image: '/images/boards/montreal/joseph-j-andrew.jpg'
        },
        {
          name: 'Audrey Azoulay',
          info: 'Director General, United Nations Educational, Scientific and Cultural Organization (UNESCO)',
          image: '/images/boards/montreal/audrey-azoulay.png'
        },
        {
          name: 'Perrin Beatty',
          info: 'President and Chief Executive Officer, The Canadian Chamber of Commerce',
          image: '/images/boards/montreal/perrin-beatty.png'
        },
        {
          name: 'David M. Cote',
          info: 'Executive Chairman, Vertiv Holdings',
          image: '/images/boards/montreal/david-m-cote.jpg'
        },
        {
          name: 'Hélène Desmarais',
          info: 'Executive Chairman, IVADO Labs and Chair of the Board HEC Montréal',
          image: '/images/boards/montreal/desmarais-helene.jpg'
        },
        {
          name: 'Jacques Delors',
          info: 'Founding President, Notre Europe, Former President European Commission',
          image: '/images/boards/montreal/jacques-delors.jpg'
        },
        {
          name: 'Orit Gadiesh',
          info: 'Chairwoman, Bain & Company',
          image: '/images/boards/montreal/orit-gadiesh.png'
        },
        {
          name: 'Glenn Hutchins',
          info: 'Co-Chairman The Brookings Institution; Chairman, North Island; and Co-founder, Silver Lake',
          image: '/images/boards/montreal/glenn-hutchins.png'
        },
        {
          name: 'Odile Renaud-Basso',
          info: 'President, European Bank for Reconstruction and Development (EBRD)',
          image: '/images/boards/montreal/odile-renaud-basso.jpg'
        },
        {
          name: 'Jean-Claude Trichet',
          info:
            'Honorary Governor, Bank of France, Former President, European Central Bank, Chairman, Group of Thirty, and Chairman of European Group of the Trilateral Commission Show',
          image: '/images/boards/montreal/jean-claude trichet.jpg'
        }
      ]
    }
  },
  archive: {
    title: 'Archives'
  },
  events: [
    {
      edition: '29th edition',
      title: 'Thriving in a world in transition',
      link: 'https://www.laconferencedemontreal.com/',
      image: '/images/events/montreal/montreal-29th-en.png'
    }
  ]
}
